module.exports = __webpack_public_path__ + "static/img/IMG_20151229_110638.9fd4b27c.jpg";